"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useGtmPageViews;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _reactRouterDom = require("react-router-dom");

function useGtmPageViews() {
  var location = (0, _reactRouterDom.useLocation)();
  var pathname = location.pathname,
      search = location.search;
  var path = "".concat(pathname).concat(search);

  _react.default.useEffect(function () {
    if (typeof window !== 'undefined') {
      var _Helmet$peek = _reactHelmet.default.peek(),
          title = _Helmet$peek.title;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'pageView',
        pagePath: path,
        pageTitle: title
      });
    }
  }, [path]);
}